enum Sections {
  AboutThePrice = 'about-the-price',
  AncillaryProducts = 'ancillary',
  BreadCrumbs = 'breadcrumbs',
  BuyWithConfidence = 'buy-with-confidence',
  Disclaimer = 'disclaimer',
  EarliestDelivery = 'earliest-delivery',
  Gallery = 'gallery',
  General = 'navigation-section',
  Hero = 'hero',
  Inspection150Point = 'inspection-150-point',
  KeyFeatures = 'key-features',
  MoreLinks = 'more-links',
  OwnerReviews = 'owner-reviews',
  PriceDetails = 'price-details',
  Root = 'root',
  RootInsurance = 'root-insurance',
  SocialProof = 'social-proof',
  Spinner = 'spinner-container',
  VehicleDetails = 'vehicle-details',
  VehiclesYouMightLike = 'vehicles-you-might-like'
}

export default Sections;
